// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RenewBuyerNeedMutation = require("../ClientPage/RenewBuyerNeedMutation.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let OwnBuyerNeedStatusLabel = require("../OwnBuyerNeedStatusLabel.bs.js");
let WithdrawBuyerNeedDialog = require("../ClientPage/WithdrawBuyerNeedDialog.bs.js");
let MarkBuyerNeedAsPurchased = require("../ClientPage/MarkBuyerNeedAsPurchased.bs.js");
let MyClientsWidgetRowLayout = require("./MyClientsWidgetRowLayout.bs.js");
let MyClientsWidgetComponents = require("./MyClientsWidgetComponents.bs.js");
let MyClientsWidgetDeleteDialog = require("./MyClientsWidgetDeleteDialog.bs.js");
let MarkBuyerNeedAsInContractDialog = require("../ClientPage/MarkBuyerNeedAsInContractDialog.bs.js");
let MyClientsWidgetBuyer_buyer_graphql = require("../../../__generated__/MyClientsWidgetBuyer_buyer_graphql.bs.js");
let MyClientsWidgetBuyer_Menu_buyer_graphql = require("../../../__generated__/MyClientsWidgetBuyer_Menu_buyer_graphql.bs.js");
let MyClientsWidgetBuyer_name_buyer_graphql = require("../../../__generated__/MyClientsWidgetBuyer_name_buyer_graphql.bs.js");
let MyClientsWidgetBuyer_status_buyer_graphql = require("../../../__generated__/MyClientsWidgetBuyer_status_buyer_graphql.bs.js");

let convertFragment = MyClientsWidgetBuyer_Menu_buyer_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetBuyer_Menu_buyer_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_Menu_buyer_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetBuyer_Menu_buyer_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetBuyer_Menu_buyer_graphql.node, convertFragment, fRef);
}

let BuyerFragment_buyerNeedMatchingType_decode = MyClientsWidgetBuyer_Menu_buyer_graphql.Utils.buyerNeedMatchingType_decode;

let BuyerFragment_buyerNeedMatchingType_fromString = MyClientsWidgetBuyer_Menu_buyer_graphql.Utils.buyerNeedMatchingType_fromString;

let BuyerFragment = {
  buyerNeedMatchingType_decode: BuyerFragment_buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: BuyerFragment_buyerNeedMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetBuyer$Menu(props) {
  let buyer = RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_Menu_buyer_graphql.node, convertFragment, props.buyer);
  let hasActivityReport = Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.map(buyer.buyerNeed.broadcasts, connection => connection.edges), [])).some(edge => {
    let match = edge.node.activityReport;
    return match.__typename === "ActivityReportV5";
  });
  let matchesCount = Stdlib_Option.getOr(Stdlib_Option.map(buyer.buyerNeed.matches, m => m.totalCount), 0);
  let match = React.useState(() => false);
  let setDeleteDialogOpen = match[1];
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  let handleRenewingError = () => addMessage(SystemMessages.Message.make(undefined, "error", "There was an error making the buyer need active. Please try again...", 5000, undefined, undefined));
  let match$2 = RenewBuyerNeedMutation.use(buyer.buyerNeed.nodeId, handleRenewingError, false);
  let makeBuyerNeedActiveIsLoading = match$2[1];
  let makeBuyerNeedActive = match$2[0];
  let match$3 = React.useState(() => false);
  let setWithdrawDialogOpen = match$3[1];
  let match$4 = React.useState(() => false);
  let setMarkAsPurchasedDialogOpen = match$4[1];
  let match$5 = React.useState(() => false);
  let setMarkAsInContractDialogOpen = match$5[1];
  let match$6 = buyer.buyerNeed.status;
  let tmp;
  switch (match$6.__typename) {
    case "ActiveBuyerNeed" :
      tmp = match$6.isRenewable ? "Renew or change status" : "Change status";
      break;
    case "ExpiredBuyerNeed" :
      tmp = "Renew or change status";
      break;
    default:
      tmp = "Change status";
  }
  let match$7 = buyer.buyerNeed.status;
  let tmp$1;
  let exit = 0;
  switch (match$7.__typename) {
    case "ActiveBuyerNeed" :
      if (match$7.isRenewable) {
        exit = 1;
      } else {
        tmp$1 = null;
      }
      break;
    case "ExpiredBuyerNeed" :
      exit = 1;
      break;
    default:
      tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => {
          makeBuyerNeedActive();
        },
        isDisabled: makeBuyerNeedActiveIsLoading,
        children: "Change to active"
      });
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => {
        makeBuyerNeedActive();
      },
      isDisabled: makeBuyerNeedActiveIsLoading,
      children: "Renew buyer need"
    });
  }
  let match$8 = buyer.buyerNeed.status;
  let tmp$2;
  tmp$2 = match$8.__typename === "PurchasedBuyerNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => setMarkAsPurchasedDialogOpen(param => true),
      children: "Mark as purchased"
    });
  let match$9 = buyer.buyerNeed.status;
  let tmp$3;
  tmp$3 = match$9.__typename === "InContractBuyerNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => setMarkAsInContractDialogOpen(param => true),
      children: "Mark as in contract"
    });
  let match$10 = buyer.buyerNeed.status;
  let tmp$4;
  tmp$4 = match$10.__typename === "WithdrawnBuyerNeed" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => setWithdrawDialogOpen(param => true),
      children: "Withdraw buyer need"
    });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(MyClientsWidgetDeleteDialog.make, {
        client: buyer.fragmentRefs,
        isOpen: match[0],
        onCancel: () => setDeleteDialogOpen(param => false),
        onSuccess: () => setDeleteDialogOpen(param => false),
        connectionId: props.connectionId
      }),
      JsxRuntime.jsx(WithdrawBuyerNeedDialog.make, {
        nodeId: buyer.buyerNeed.nodeId,
        isOpen: match$3[0],
        close: () => setWithdrawDialogOpen(param => false)
      }),
      JsxRuntime.jsx(MarkBuyerNeedAsPurchased.make, {
        nodeId: buyer.buyerNeed.nodeId,
        isOpen: match$4[0],
        close: () => setMarkAsPurchasedDialogOpen(param => false)
      }),
      JsxRuntime.jsx(MarkBuyerNeedAsInContractDialog.make, {
        nodeId: buyer.buyerNeed.nodeId,
        isOpen: match$5[0],
        close: () => setMarkAsInContractDialogOpen(param => false)
      }),
      JsxRuntime.jsxs(MenuV5.Menu.make, {
        button: JsxRuntime.jsx(ButtonsV5.Button.make, {
          className: "!border-none",
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "three-dots",
            size: 16,
            className: "text-black"
          })
        }),
        children: [
          JsxRuntime.jsx(MenuV5.MenuItem.make, {
            href: `/client_needs/` + buyer.buyerNeed.id + `/edit`,
            children: "Edit buyer need"
          }),
          buyer.buyerNeed.buyerNeedMatchingType === "QUIET" ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: `/client_needs/` + buyer.buyerNeed.id + `/broadcast`,
              children: "Broadcast buyer need"
            }) : null,
          JsxRuntime.jsxs(MenuV5.Submenu.make, {
            name: tmp,
            children: [
              tmp$1,
              tmp$2,
              tmp$3,
              tmp$4
            ]
          }),
          matchesCount > 0 ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: `/my_clients/` + buyer.id + `#matches`,
              children: `View matches (` + matchesCount.toString() + `)`
            }) : null,
          hasActivityReport ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
              href: `/client_needs/` + buyer.buyerNeed.id + `/report`,
              children: "View activity report"
            }) : null,
          JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: () => setDeleteDialogOpen(param => true),
            children: "Delete buyer"
          })
        ]
      })
    ]
  });
}

let Menu = {
  BuyerFragment: BuyerFragment,
  make: MyClientsWidgetBuyer$Menu
};

let convertFragment$1 = MyClientsWidgetBuyer_name_buyer_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetBuyer_name_buyer_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_name_buyer_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetBuyer_name_buyer_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetBuyer_name_buyer_graphql.node, convertFragment$1, fRef);
}

let BuyerFragment_buyerNeedMatchingType_decode$1 = MyClientsWidgetBuyer_name_buyer_graphql.Utils.buyerNeedMatchingType_decode;

let BuyerFragment_buyerNeedMatchingType_fromString$1 = MyClientsWidgetBuyer_name_buyer_graphql.Utils.buyerNeedMatchingType_fromString;

let BuyerFragment$1 = {
  buyerNeedMatchingType_decode: BuyerFragment_buyerNeedMatchingType_decode$1,
  buyerNeedMatchingType_fromString: BuyerFragment_buyerNeedMatchingType_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyClientsWidgetBuyer$Name(props) {
  let buyer = RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_name_buyer_graphql.node, convertFragment$1, props.buyer);
  let registrationState = Stdlib_Array.reduce(Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.map(buyer.contacts, contacts => contacts.edges), [])), "Uninvited", (acc, contact) => {
    let match = contact.node.clientAccessStatus;
    switch (acc) {
      case "Uninvited" :
        switch (match.__typename) {
          case "ClientContactInvited" :
            return "Invited";
          case "ClientContactRegistered" :
          case "__unselected" :
            break;
        }
        break;
      case "Registered" :
        return acc;
      case "Invited" :
        break;
    }
    switch (match.__typename) {
      case "ClientContactRegistered" :
        return "Registered";
      case "ClientContactInvited" :
      case "__unselected" :
        return acc;
    }
  });
  let match = buyer.buyerNeed.matchingType;
  let buyerNeedType = match !== undefined && (match === "BROADCAST" || match === "QUIET") ? (
      match === "BROADCAST" ? "Broadcast buyer need" : "Quiet buyer need"
    ) : "Buyer need";
  let tmp;
  switch (registrationState) {
    case "Uninvited" :
      tmp = "";
      break;
    case "Registered" :
      tmp = " (registered)";
      break;
    case "Invited" :
      tmp = " (invited)";
      break;
  }
  let match$1 = buyer.buyerNeed.autoNotify;
  let tmp$1;
  if (match$1 !== undefined && match$1) {
    switch (registrationState) {
      case "Uninvited" :
        tmp$1 = null;
        break;
      case "Registered" :
      case "Invited" :
        tmp$1 = JsxRuntime.jsx(MyClientsWidgetComponents.AutoNotifyIcon.make, {});
        break;
    }
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: buyerNeedType + tmp,
            className: "text-gray-500 uppercase font-light"
          }),
          tmp$1
        ],
        className: "flex gap-2 items-center"
      }),
      JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: `my_clients/` + buyer.id,
        children: JsxRuntime.jsx("div", {
          children: buyer.displayName,
          className: "text-lg"
        })
      })
    ],
    className: "flex flex-col gap-1"
  });
}

let Name = {
  BuyerFragment: BuyerFragment$1,
  make: MyClientsWidgetBuyer$Name
};

let convertFragment$2 = MyClientsWidgetBuyer_status_buyer_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetBuyer_status_buyer_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_status_buyer_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetBuyer_status_buyer_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetBuyer_status_buyer_graphql.node, convertFragment$2, fRef);
}

let BuyerFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyClientsWidgetBuyer$Status$WithoutErrorBoundary(props) {
  let buyer = RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_status_buyer_graphql.node, convertFragment$2, props.buyer);
  return JsxRuntime.jsx(OwnBuyerNeedStatusLabel.make, {
    buyerNeed: buyer.buyerNeed.fragmentRefs
  });
}

let WithoutErrorBoundary = {
  BuyerNeedStatusLabel: undefined,
  BuyerFragment: BuyerFragment$2,
  make: MyClientsWidgetBuyer$Status$WithoutErrorBoundary
};

function MyClientsWidgetBuyer$Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "buyer status",
    children: JsxRuntime.jsx(MyClientsWidgetBuyer$Status$WithoutErrorBoundary, {
      buyer: props.buyer
    })
  });
}

let Status = {
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: MyClientsWidgetBuyer$Status
};

let convertFragment$3 = MyClientsWidgetBuyer_buyer_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetBuyer_buyer_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_buyer_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyClientsWidgetBuyer_buyer_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetBuyer_buyer_graphql.node, convertFragment$3, fRef);
}

let BuyerFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function MyClientsWidgetBuyer(props) {
  let buyer = RescriptRelay_Fragment.useFragment(MyClientsWidgetBuyer_buyer_graphql.node, convertFragment$3, props.buyer);
  return JsxRuntime.jsx(MyClientsWidgetRowLayout.make, {
    name: JsxRuntime.jsx(MyClientsWidgetBuyer$Name, {
      buyer: buyer.fragmentRefs
    }),
    status: JsxRuntime.jsx(MyClientsWidgetBuyer$Status, {
      buyer: buyer.fragmentRefs
    }),
    menu: JsxRuntime.jsx(MyClientsWidgetBuyer$Menu, {
      buyer: buyer.fragmentRefs,
      connectionId: props.connectionId
    })
  });
}

let Layout;

let Components;

let Link;

let DeleteDialog;

let make = MyClientsWidgetBuyer;

exports.Layout = Layout;
exports.Components = Components;
exports.Link = Link;
exports.DeleteDialog = DeleteDialog;
exports.Menu = Menu;
exports.Name = Name;
exports.Status = Status;
exports.BuyerFragment = BuyerFragment$3;
exports.make = make;
/* react Not a pure module */
